import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(() => ({
  qrBody: {
    width: "100%",
  },
  amountSection: {
    backgroundColor: "#F0F0F0",
    "& > p": {},
  },
}));
